import * as React from "react"
import { NavUser } from "@/components/nav/NavUser"

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar"
import { NavSystemAdmin } from "@/components/nav/NavSystemAdmin"
import type { CurrentUser, CurrentUserFull, CurrentUserOrg } from "@/types/index"
import { NavMain } from "@/components/nav/NavMain"
import { NavOrgs } from "@/components/nav/NavOrgs"
import logo from "@/assets/logo/logo_colour.jpeg";

interface AppSidebarProps extends React.ComponentProps<typeof Sidebar> {
  currentUser: CurrentUserFull;
}

import { useSidebar } from "@/components/ui/sidebar";

export function AppSidebar({ currentUser, ...props }: AppSidebarProps) {
  const user = currentUser.user
  const data: {
    user: CurrentUser
    organisations: CurrentUserOrg[]
  } = {
    user: currentUser.user,
    organisations: currentUser.organisations,
  }

  const { state } = useSidebar();

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <div className="flex items-center gap-2 py-2 px-3">
          <img
            src={logo}
            alt="Tyto Bio Logo"
            className="w-8 h-8 object-contain"
          />
          {state === "expanded" && (
            <span className="text-xl font-semibold tracking-tight text-primary">Tyto Bio</span>
          )}
        </div>
      </SidebarHeader>
      <SidebarContent>
        <NavMain />
        <NavOrgs />
        {user.role === "ADMIN" && <NavSystemAdmin />}
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={data} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
